import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { GenericSvg } from "../../../assets/svgs/GenericSVG";
import { CustomButton } from "../../../core/components/buttons/CustomButton";
import { Mini } from "../../../core/styles/stringStyles";
import { useStyles } from "../../../core/styles/theme";

type Props = {
  textColor?: string;
  className?: string;
};

export const FOOTER_HEIGHT = 50;

const PRIVACY_PAGE_URL =
  import.meta.env.VITE_ENV === "production"
    ? "https://services.physiofit.app/datenschutz"
    : "https://services-physiofit-dev.web.app/datenschutz";

export const Footer = ({ textColor, className }: Props) => {
  const { t } = useTranslation();
  const theme = useStyles();

  const openPrivacyPolicy = () => {
    window.open(PRIVACY_PAGE_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Container className={className}>
      <Text style={{ color: textColor }}>{t("FOOTER_TEXT_1")}</Text>
      <GenericSvg
        name="PhysiofitLogo"
        primaryColor={textColor ?? theme.colors.white}
        width={100}
      />
      <SeparationDot style={{ backgroundColor: textColor }} />
      <CustomButton onClick={openPrivacyPolicy}>
        <Text style={{ color: textColor }}>{t("FOOTER_TEXT_2")}</Text>
      </CustomButton>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  opacity: 40%;
  padding: 10px 20px 10px 20px;
  height: ${FOOTER_HEIGHT}px;
`;

const Text = styled(Mini)`
  color: ${(props) => props.theme.colors.white};
`;

const SeparationDot = styled.div`
  width: 4px;
  height: 4px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 2px;
`;
